<template>
    <span class="inline-flex w-3/5 h-12 mb-6 rounded-md ">
        <button
            @click="clicked"
            v-bind="$attrs"
            type="button"
            class="inline-flex items-center justify-center min-w-full px-6 py-3 text-base font-semibold leading-6 text-white transition duration-150 ease-in-out bg-green-500 border border-transparent rounded-md hover:bg-green-400 focus:outline-none focus:border-green-600 focus:shadow-outline-blue active:bg-green-600"
        >
            {{ title }}
        </button>
    </span>
</template>
<script>
export default {
    inheritAttrs: false,

    props: {
        title: {
            type: String,
            required: true
        }
    },
    methods: {
        clicked() {
            this.$emit("click");
        }
    }
};
</script>
